/**
 * Loads something once and remembers it: repeated calls share one download, the result is
 * available synchronously afterwards, and a failed download may be tried again.
 */
export function loadOnce<T>(load: () => Promise<T>): { preload: () => Promise<T>; loaded: () => T | undefined } {
  let value: T | undefined;
  let pending: Promise<T> | undefined;
  const preload = () => pending ??= load().then(v => (value = v), error => { pending = undefined; throw error; });
  return { preload, loaded: () => value };
}
